/**
 * Student inspiration archive (/portal/ideas).
 *
 * Identical accordion as admin but read-only and shows only published
 * articles (filtered server-side by /api/inspirations endpoints).
 */
import { useTranslation } from "react-i18next";
import PortalPageHeader from "../../components/portal/PortalPageHeader";
import InspirationArchive from "../../components/inspirations/InspirationArchive";

export default function PortalInspirations() {
  const { t } = useTranslation();
  return (
    <div data-testid="portal-inspirations-page" className="space-y-10">
      <PortalPageHeader
        kickerKey="portal.placeholder.kicker"
        titleKey="portal.nav.ideas"
        subtitleKey="portal.pages.ideas_desc"
      />
      <InspirationArchive mode="read" basePath="/portal/ideas" />
    </div>
  );
}
